import React from 'react'
import { Descriptions, Modal } from 'antd';
import moment from 'moment';
import styles from '../index.less';

export default function ReasonModal(props) {

  const { visible, initValue = {}, onCancel } = props;

  return (
    <Modal
      title={initValue.paymentType === 'payment'?'升单原因':'退款原因'}
      visible={visible}
      footer={null}
      onCancel={() => { onCancel && onCancel() }}
      layout='vertical'
      wrapClassName={styles.reasonModal}
    >
      <Descriptions column={1}>

        {/* <Descriptions.Item label=''></Descriptions.Item> */}
        <Descriptions.Item label={initValue.paymentType === 'payment'?'收款日期':'退款时间'} >{initValue.paymentType === 'payment'?initValue.receiptDate&&moment(initValue.receiptDate).format('YYYY-MM-DD'):initValue.refundDate&&moment(initValue.refundDate).format('YYYY-MM-DD')}</Descriptions.Item>
        {/* <Descriptions.Item label=''></Descriptions.Item>
        <Descriptions.Item label=''></Descriptions.Item> */}
        <Descriptions.Item label={initValue.paymentType === 'payment'?'收款商品':'商品名称'}>{initValue.productName}</Descriptions.Item>
        {/* <Descriptions.Item label=''></Descriptions.Item>
        <Descriptions.Item label=''></Descriptions.Item> */}
        <Descriptions.Item label={initValue.paymentType === 'payment'?'收款频次':'退款次数'}>{initValue.quantity}</Descriptions.Item>
        {/* <Descriptions.Item label=''></Descriptions.Item>
        <Descriptions.Item label=''></Descriptions.Item> */}
        <Descriptions.Item label={initValue.paymentType === 'payment'?'触发规则':'退款金额'}>{initValue.paymentType === 'payment'?initValue.trigger:(initValue.amount&&initValue.amount.toFixed(2))}</Descriptions.Item>
        {/* <Descriptions.Item label=''></Descriptions.Item>
        <Descriptions.Item label=''></Descriptions.Item> */}
        <Descriptions.Item label={initValue.paymentType === 'payment'?'规则内容':'退款原因'}>{initValue.comment}</Descriptions.Item>
        {/* <Descriptions.Item label=''></Descriptions.Item> */}

      </Descriptions>
    </Modal>
  )
}
